import m from "react";
import { useTheme as _, ModalFooter as g, Flex as E } from "@chakra-ui/react";
import "react-icons/md";
import { Button as u } from "../../atoms/button/button.js";
import "../../atoms/button/icon-button.js";
import "react-icons/fa";
import "@loadable/component";
import "../../atoms/button/masthead-button.js";
import { getFocusIndicator as h } from "../../../utils/accessibilityUtils.js";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "../../atoms/button/close-button.js";
import { Divider as k } from "../../atoms/divider/divider.js";
import { ButtonLink as d } from "../../atoms/link/button-link.js";
const w = ({
  callToAction1: e,
  callToAction2: r,
  ctaClickHandler: p,
  onClose: f,
  centered: n = !1
}) => {
  const {
    element: { spacingMedium: o, spacingExtraLarge: x },
    surface: { default: v }
  } = _(), a = h(v), s = (t, i) => {
    t.preventDefault(), i ? p(i) : f();
  };
  return /* @__PURE__ */ m.createElement(g, { display: "block" }, /* @__PURE__ */ m.createElement(k, null), /* @__PURE__ */ m.createElement(
    E,
    {
      justifyContent: n ? "center" : "flex-start",
      gap: o,
      pt: x
    },
    r && (r == null ? void 0 : r.url) && /* @__PURE__ */ m.createElement(
      d,
      {
        onClick: (t) => s(t, r.url),
        href: r.url,
        _hover: { textDecoration: "none" },
        "data-testid": "modal-cta-2",
        size: "large",
        variant: "primary",
        _focusVisible: a
      },
      r.text
    ),
    r && !(r != null && r.url) && /* @__PURE__ */ m.createElement(
      u,
      {
        onClick: (t) => s(t, null),
        _hover: { textDecoration: "none" },
        "data-testid": "modal-cta-2",
        size: "large",
        variant: "primary",
        _focusVisible: a
      },
      r.text
    ),
    e && (e == null ? void 0 : e.url) && /* @__PURE__ */ m.createElement(
      d,
      {
        onClick: (t) => s(t, e.url),
        href: e.url,
        _hover: { textDecoration: "none" },
        size: "large",
        variant: "secondary",
        "data-testid": "modal-cta",
        _focusVisible: a
      },
      e.text
    ),
    e && !(e != null && e.url) && /* @__PURE__ */ m.createElement(
      u,
      {
        onClick: (t) => s(t, null),
        _hover: { textDecoration: "none" },
        size: "large",
        variant: "secondary",
        "data-testid": "modal-cta",
        _focusVisible: a
      },
      e.text
    )
  ));
};
export {
  w as ModalFooter
};
